module.exports = __webpack_public_path__ + "img/rifle.d1a46c8a.svg";